module.exports = __webpack_public_path__ + "static/media/guide_img1_3.b244fc10.png";